export { DetailsHeader } from './DetailsHeader';
